// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataCachingConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { observable, action } from 'mobx';

export default class DataCachingConfiguration {
  @observable isEnableDataCache = null;
  @observable timeToLive = null;
  @observable evictionInterval = null;
  @observable refreshInterval = null;
  @observable refreshDuration = null;
  defaultIsEnableDataCache = null;
  defaultTimeToLive = null;
  defaultEvictionInterval = null;
  defaultRefreshInterval = null;
  defaultRefreshDuration = null;

  constructor(data: any) {
    data && this.populateData(data);
  }

  /**
   * Set value by key
   * @param {string} key
   * @param {any} value
   */
  setValueByKey(key: string, value: any) {
    this[key] = value;
  }

  /**
   * Populate Data
   */
  @action
  populateData(data: any) {
    this.isEnableDataCache = data.isEnableDataCache;
    this.timeToLive = data.timeToLive;
    this.evictionInterval = data.evictionInterval;
    this.refreshInterval = data.refreshInterval;
    this.refreshDuration = data.refreshDuration;
    this.defaultIsEnableDataCache = data.defaultIsEnableDataCache;
    this.defaultTimeToLive = data.defaultTimeToLive;
    this.defaultEvictionInterval = data.defaultEvictionInterval;
    this.defaultRefreshInterval = data.defaultRefreshInterval;
    this.defaultRefreshDuration = data.defaultRefreshDuration;
  }

  buildDataForSave() {
    return {
      isEnableDataCache: this.isEnableDataCache,
      timeToLive: this.timeToLive,
      evictionInterval: this.evictionInterval,
      refreshInterval: this.refreshInterval,
      refreshDuration: this.refreshDuration
    };
  }
}



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.DataCachingConfiguration.js